module.exports = __webpack_public_path__ + "static/media/KPW.992a6627.png";